import { Check, MapPin } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator
} from '@/components/ui/command';

import { useProjectSiteSelector } from '../model/use-project-site-selector';

export const ProjectSiteSelector = ({ children }: { children: React.ReactNode }) => {
  const { open, setOpen, listRef, projects, projectId, siteId, selectedValue, selectSite, selectFirstSite } =
    useProjectSiteSelector();

  if (!projects) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="p-0 w-80" align="start">
        <Command className="rounded-lg" defaultValue={selectedValue}>
          <CommandInput placeholder="Search projects and sites..." />
          <CommandList ref={listRef}>
            <CommandEmpty>No projects or sites found.</CommandEmpty>

            {projects.map((project, index) => (
              <div key={project.id}>
                {index > 0 && <CommandSeparator />}
                <CommandGroup
                  heading={
                    <button
                      type="button"
                      tabIndex={-1}
                      onClick={(event) => selectFirstSite(event.currentTarget, project.id)}
                      className="block w-full text-left cursor-pointer hover:text-foreground">
                      {project.name}
                    </button>
                  }
                  className="overflow-visible [&_[cmdk-group-heading]]:sticky [&_[cmdk-group-heading]]:top-0 [&_[cmdk-group-heading]]:z-10 [&_[cmdk-group-heading]]:-mx-1 [&_[cmdk-group-heading]]:bg-popover [&_[cmdk-group-heading]]:px-3">
                  {project.sites.map((site) => {
                    const isSelected = projectId === project.id && siteId === site.id;
                    return (
                      <CommandItem
                        key={`${project.id}-${site.id}`}
                        value={`${project.name} ${site.name}`}
                        data-site-id={site.id}
                        onSelect={() => selectSite(project.id, site.id)}
                        className="cursor-pointer scroll-mt-7">
                        <MapPin className="mr-2 h-4 w-4 text-muted-foreground" />
                        <span className="flex-1">{site.name}</span>
                        {isSelected && <Check className="ml-2 h-4 w-4 text-primary" />}
                      </CommandItem>
                    );
                  })}
                </CommandGroup>
              </div>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
